"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.DeliveryOptionsDialog = void 0;
var _components = require("@ori-ui/components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _SearchConfigurationProvider = require("../../containers/SearchConfigurationProvider");
var _contexts = require("../../contexts");
var _addressFormContext = require("../../contexts/addressFormContext");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _Loading = require("../Loading");
var _DeliveryOptionsDialogContent = require("./DeliveryOptionsDialogContent");
var _styles = require("./styles");
var _usePickupPointsDialog = require("./usePickupPointsDialog");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const AddressForm = /*#__PURE__*/ (0, _react.lazy)(async ()=>({
        default: (await Promise.resolve().then(()=>_interopRequireWildcard(require('@ori/address-form')))).DeliveryAddressForm
    }));
const ConfirmDeleteAddressDialog = /*#__PURE__*/ (0, _react.lazy)(async ()=>Promise.resolve().then(()=>_interopRequireWildcard(require('../addresses/ConfirmDeleteAddressDialog'))));
const SelectPickupPointDialog = /*#__PURE__*/ (0, _react.lazy)(async ()=>Promise.resolve().then(()=>_interopRequireWildcard(require('../SelectPickupPointDialog/SelectPickupPointDialog'))));
const DeliveryOptionsDialog = (param)=>{
    let { isAddHomeDeliveryAddressAllowed, isDisplayingAddresses, isMapEnabled, isPickUpAvailable, lastDeliveryItemFee, lastDeliveryItemMethod, setIsDisplayingAddresses, isFlatSelection, isDeliveryOptionsLoaded, onDeliveryItemActivation, selectedItem, toggleDeliveryOptionsDialog, ...props } = param;
    const { formatMessage } = (0, _hooks.useTranslations)();
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const { isFindPickupPointsOpen, togglePickupPointsDialog } = (0, _usePickupPointsDialog.usePickupPointsDialog)();
    const { addressFormProps, addressFormTitle, confirmDeleteAddressDialogProps, isAddressFormOpen, isConfirmDeleteAddressDialogOpen } = (0, _addressFormContext.useAddressForm)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Dialog, {
                open: true,
                fullWidth: true,
                disableEnforceFocus: isFindPickupPointsOpen,
                header: formatMessage('deliveryOptions'),
                maxWidth: "700px",
                onClose: toggleDeliveryOptionsDialog,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_DeliveryOptionsDialogContent.DeliveryOptionsDialogContent, {
                    ...props,
                    selectedItem: selectedItem,
                    isDisplayingAddresses: isDisplayingAddresses,
                    setIsDisplayingAddresses: setIsDisplayingAddresses,
                    isFlatSelection: isFlatSelection,
                    isDeliveryOptionsLoaded: isDeliveryOptionsLoaded,
                    isPickUpAvailable: isPickUpAvailable,
                    isAddHomeDeliveryAddressAllowed: isAddHomeDeliveryAddressAllowed,
                    newDeliveryProps: {
                        isAddHomeDeliveryAddressAllowed,
                        isPickUpAvailable,
                        lastDeliveryItemFee,
                        lastDeliveryItemMethod,
                        togglePickupPointsDialog
                    },
                    historyToggleProps: {
                        ...getTestIdProps(_models.TestId.DeliveryToggleHistoryAddress),
                        checked: isDisplayingAddresses,
                        firstText: formatMessage('history'),
                        secondText: formatMessage('addresses'),
                        onChange: (e)=>setIsDisplayingAddresses(e.currentTarget.checked)
                    },
                    onDeliveryItemActivation: onDeliveryItemActivation
                })
            }),
            isDeliveryOptionsLoaded ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Suspense, {
                fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Loading.DialogLoadingOverlay, {
                    id: _models.TestId.DialogLoadingOverlayFindPickupPoints
                }),
                children: isFindPickupPointsOpen ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_SearchConfigurationProvider.SearchConfigurationProvider, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_contexts.MapProvider, {
                        deliveryChannelId: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.deliveryChannelId,
                        togglePickupPointsDialog: togglePickupPointsDialog,
                        onDeliveryItemActivation: onDeliveryItemActivation,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_contexts.PickupPointsProvider, {
                            enabled: isFindPickupPointsOpen,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectPickupPointDialog, {
                                open: isFindPickupPointsOpen
                            })
                        })
                    })
                }) : null
            }) : null,
            isAddressFormOpen ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.AddressFormWrapper, {
                open: true,
                header: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.AddressFormTitle, {
                    variant: "h5",
                    component: "div",
                    children: addressFormTitle
                }),
                "aria-label": addressFormTitle,
                maxWidth: "700px",
                onClose: addressFormProps.configForm.onCloseDialog,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Suspense, {
                    fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Loading.DialogLoadingOverlay, {
                        id: _models.TestId.DialogLoadingOverlayAddressForm
                    }),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AddressForm, {
                        ...addressFormProps
                    })
                })
            }) : null,
            isConfirmDeleteAddressDialogOpen ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Suspense, {
                fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Loading.DialogLoadingOverlay, {
                    id: _models.TestId.DialogLoadingOverlayConfirmDeleteAddress
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConfirmDeleteAddressDialog, {
                    ...confirmDeleteAddressDialogProps
                })
            }) : null
        ]
    });
};
exports.DeliveryOptionsDialog = DeliveryOptionsDialog;
var _default = exports.default = DeliveryOptionsDialog;
